<interacta-user-notification [notification]="notification()">
    <div class="mt-8 flex items-center gap-x-4">
        @if (fromState(); as fromState) {
            <interacta-workflow-state-badge
                [color]="fromState.metadata.styleColor"
                [colorCode]="fromState.metadata.styleColorCode"
                [size]="'small'"
                [workflowStateName]="fromState.name"
            />
        }
        <interacta-icon class="size-20" [icon]="'arrow-right'" />
        @if (notification().aggregated) {
            <interacta-icon class="size-20" [icon]="'ellipsis-horizontal'" />
            <interacta-icon class="size-20" [icon]="'arrow-right'" />
        }
        @if (toState(); as toState) {
            <interacta-workflow-state-badge
                [color]="toState.metadata.styleColor"
                [colorCode]="toState.metadata.styleColorCode"
                [size]="'small'"
                [workflowStateName]="toState.name"
            />
        }
    </div>
</interacta-user-notification>
